import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import GetDiseaseChart from './GetDiseaseChart';

export default function DiseaseSubCard() {


    return(

<Grid container sx={{bgcolor:'greydark.C500', borderRadius:'8px' }}>  

  <Grid size={12} sx={{mt: 2.5, ml:2.5, display:'flex', justifyContent:'flex-start', alignItems:'center', }}>    
    <Typography variant="h6" sx={{color: 'common.white'}}> EPIGENETIC DISEASE RISK </Typography>        
  </Grid>

        
   <Grid size={12} sx={{ display:'flex', justifyContent:'center', alignItems:'flex-start', }}> <GetDiseaseChart />   </Grid>

</Grid>
    
    )
}